import React from 'react'

const Arr_rev = () => {
    return (
        <div className='container'>
            <h1>Write a program to reverse an array </h1>
            <br /> <br />
            <p>Given an array (or string), the task is to reverse the array/string.</p>
            <p><strong>Examples:</strong></p>
            <div className='output'>
Input  : arr[] =&#123;1, 2, 3&#125; <br />
Output : arr[] =&#123;3, 2, 1&#125; <br />
<br />
Input :  arr[] =&#123;4, 5, 1, 2&#125; <br />
Output : arr[] =&#123;2, 1, 5, 4&#125; <br />
<br />
</div>
<p><strong>Iterative way :</strong></p>
<p>1) Initialize start and end indexes as start = 0, end = n-1&nbsp;<br/>
2) In a loop, swap arr[start] with arr[end] and change start and end as follows :&nbsp;<br/>
start = start +1, end = end – 1</p>
<br />
<div className='containers'>
<div class="container">
    <div class="line number1 index0 alt2"><code class="comment">// Program to reverse an array</code>
    </div> <br/>
    <div class="line number2 index1 alt1"><code class="library">#include &lt;bits/stdc++.h&gt;</code></div> <br/>
    <div class="line number3 index2 alt2"><code class="keywords">using</code> <code
            class="keywords">namespace</code> <code class="plain">std;</code></div> <br/>

    <div class="line number5 index4 alt2"><code class="comment">/* Function to reverse arr[] from start to end*/</code>
    </div> <br/>
    <div class="line number6 index5 alt1"><code class="keywords">void</code> <code
            class="plain">rvereseArray(</code><code class="library">int</code> <code
            class="plain">arr[], </code><code class="library">int</code> <code class="plain">start, </code><code
            class="library">int</code> <code class="plain">end)</code></div> <br/>
    <div class="line number7 index6 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number8 index7 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">while</code> <code class="plain">(start &lt; end)</code></div> <br/>
    <div class="line number9 index8 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#123;</code></div> <br/>
    <div class="line number10 index9 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">temp = arr[start];</code></div> <br/>
    <div class="line number11 index10 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr[start] = arr[end];</code></div> <br/>
    <div class="line number12 index11 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">arr[end] = temp;</code></div> <br/>
    <div class="line number13 index12 alt2"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">start++;</code></div> <br/>
    <div class="line number14 index13 alt1"><code
            class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">end--;</code></div> <br/>
    <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">&#125;</code></div> <br/>
    <div class="line number16 index15 alt1"><code class="plain">&#125;&nbsp;&nbsp;&nbsp;&nbsp;</code></div> <br/>

    <div class="line number18 index17 alt1"><code class="comment">/* function to print an array */</code></div> <br/>
    <div class="line number19 index18 alt2"><code class="keywords">void</code> <code
            class="plain">printArray(</code><code class="library">int</code> <code class="plain">arr[], </code><code
            class="library">int</code> <code class="plain">size)</code></div> <br/>
    <div class="line number20 index19 alt1"><code class="plain">&#123;</code></div> <br/>
    <div class="line number21 index20 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">for</code> <code class="plain">(</code><code class="library">int</code> <code
            class="plain">i = 0; i &lt; size; i++)</code></div> <br/>
    <div class="line number22 index21 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; arr[i] &lt;&lt; </code><code class="string">" "</code><code
            class="plain">;</code></div> <br/>

    <div class="line number24 index23 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; endl;</code></div> <br/>
    <div class="line number25 index24 alt2"><code class="plain">&#125;</code></div> <br/>
 <br/>
    <div class="line number28 index27 alt1"><code class="library">int</code> <code class="plain">main()</code></div> <br/>
    <div class="line number29 index28 alt2"><code class="plain">&#123;</code></div> <br/>
    <div class="line number30 index29 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">arr[] = &#123;1, 2, 3, 4, 5, 6&#125;;</code></div> <br/>
    <div class="line number31 index30 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> <br/>
    <div class="line number32 index31 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="library">int</code> <code class="plain">n = </code><code class="keywords">sizeof</code><code
            class="plain">(arr) / </code><code class="keywords">sizeof</code><code class="plain">(arr[0]);</code>
    </div> <br/>

    <div class="line number34 index33 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// To print original array</code></div> <br/>
    <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">printArray(arr, n);</code></div> <br/>
    <div class="line number36 index35 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> <br/>
    <div class="line number37 index36 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// Function calling</code></div> <br/>
    <div class="line number38 index37 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">rvereseArray(arr, 0, n-1);</code></div> <br/>
    <div class="line number39 index38 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> <br/>
    <div class="line number40 index39 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">cout &lt;&lt; </code><code class="string">"Reversed array is"</code> <code
            class="plain">&lt;&lt; endl;</code></div> <br/>
    <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> <br/>
    <div class="line number42 index41 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="comment">// To print the Reversed array</code></div> <br/>
    <div class="line number43 index42 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="plain">printArray(arr, n);</code></div> <br/>
    <div class="line number44 index43 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code>&nbsp;</div> <br/>
    <div class="line number45 index44 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
            class="keywords">return</code> <code class="plain">0;</code></div> <br/>
    <div class="line number46 index45 alt1"><code class="plain">&#125;</code></div>
</div> <br/>
</div>
<div className='output'>
1 2 3 4 5 6 <br />
Reversed array is <br />
6 5 4 3 2 1 <br />
</div>

        </div>
    )
}

export default Arr_rev
